import * as Sentry from '@sentry/angular'
import { bootstrapApplication } from '@angular/platform-browser'
import { appConfig } from './app/app.config'
import { AppComponent } from './app/app.component'
import { environment } from '@environments/environment'

Sentry.init({
	dsn: 'https://53bb1839e4c43a0a5dd52a06453e56ca@o4509310446796800.ingest.de.sentry.io/4509314325872720',
	environment: environment.production ? 'production' : 'development',
	sendDefaultPii: true,
	integrations: [
		Sentry.browserTracingIntegration(),
		Sentry.replayIntegration({
			maskAllText: environment.production,
			blockAllMedia: true,
		}),
	],
	tracesSampleRate: environment.production ? 0.1 : 1.0,
	replaysSessionSampleRate: environment.production ? 0.05 : 1.0,
	replaysOnErrorSampleRate: environment.production ? 1.0 : 1.0,
})

bootstrapApplication(AppComponent, appConfig).catch((err: Error): void => console.error(err))
